module.exports = __webpack_public_path__ + "img/tm.ae4124ab.svg";